import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {DeleteViewContent} from '../components/delete/DeleteViewContent'
import {CodeViewHeaderDataRouter} from '../components/headers/CodeViewHeader'
import {DeleteHeaderButtons} from '../components/headers/header-components/DeleteHeaderButtons'
import {codeViewDeleteRoute} from '../routes/code-view-delete-route'
import {CodeView} from './CodeView'

export function CodeViewDeleteEntrypoint() {
  const {data: payload} = useRouteQuery(codeViewDeleteRoute, 'mainQuery')

  const actions = <DeleteHeaderButtons webCommitInfo={payload.webCommitInfo} isBlob={payload.deleteInfo.isBlob} />

  return (
    <>
      <CodeViewHeaderDataRouter narrowActions={actions} wideActions={actions} />
      <CodeView payload={payload} action="tree">
        {() => <DeleteViewContent deleteInfo={payload.deleteInfo} webCommitInfo={payload.webCommitInfo} />}
      </CodeView>
    </>
  )
}
